/* pippei.no – gravering koblet til produktlinje (Kalles) */
(function () {
  'use strict';
  if (!window.T4Sroutes) return;
  var ADD = T4Sroutes.cart_add_url + '.js';
  var CHANGE = T4Sroutes.cart_change_url + '.js';
  var CART = window.Shopify.routes.root + 'cart.js';

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || ('HTTP ' + r.status));
        return j;
      });
    });
  }
  function newId() { return 'g' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7); }

  /* Del A – produktside: legg til produkt + valgte graveringer i ett kall */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest ? ev.target.closest('[data-atc-form]') : null;
    if (!btn) return;
    var form = btn.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var chosen = form.querySelectorAll('[data-pippei-gravering-variant]:checked');
    if (!chosen.length) return;                       // ingen gravering: temaets vanlige flyt
    ev.preventDefault(); ev.stopPropagation();
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true' || btn.dataset.pippeiBusy) return;

    var fd = new FormData(form), props = {};
    fd.forEach(function (v, k) {
      var m = k.match(/^properties\[(.+)\]$/);
      if (m && v !== '') props[m[1]] = v;             // tar med f.eks. _Forventet klar
    });
    var id = newId();
    props._gravering_id = id;
    var items = [{ id: fd.get('id'), quantity: parseInt(fd.get('quantity'), 10) || 1, properties: props }];
    var block = form.querySelector('[data-pippei-gravering]');
    var title = block ? block.getAttribute('data-pippei-produkt') : '';
    chosen.forEach(function (cb) {
      var gprops = { _gravering_for: id, 'Gravering til': title };
      var forventet = cb.getAttribute('data-pippei-gravering-forventet');
      if (forventet) gprops['Forventet klar'] = forventet;   // synlig i kassen (Knut 2026-09-24), som på produktlinjen
      items.push({ id: cb.getAttribute('data-pippei-gravering-variant'), quantity: 1, properties: gprops });
    });

    btn.dataset.pippeiBusy = '1'; btn.setAttribute('aria-busy', 'true');
    post(ADD, { items: items })
      .then(function () {
        chosen.forEach(function (cb) { cb.checked = false; });
        document.dispatchEvent(new CustomEvent('cart:refresh:opend'));   // temaet henter og åpner minihandlekurven
      })
      .catch(function (e) {
        if (window.T4SThemeSP && T4SThemeSP.Notices) T4SThemeSP.Notices(e.message); else alert(e.message);
      })
      .finally(function () { delete btn.dataset.pippeiBusy; btn.removeAttribute('aria-busy'); });
  }, true);

  /* Del B – vakt: fjern foreldreløse graveringer, stryk brutte koblinger */
  var busy = false;
  function reconcile() {
    if (busy) return;
    busy = true;
    fetch(CART, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ids = {}, fors = {};
        cart.items.forEach(function (it) {
          var p = it.properties || {};
          if (p._gravering_id) ids[p._gravering_id] = 1;
          if (p._gravering_for) fors[p._gravering_for] = 1;
        });
        var ops = [];
        cart.items.forEach(function (it) {
          var p = it.properties || {};
          if (p._gravering_for && !ids[p._gravering_for]) {
            // gravering uten produkt: fjern
            ops.push(function () { return post(CHANGE, { id: it.key, quantity: 0 }); });
          } else if (p._gravering_id && !fors[p._gravering_id]) {
            // produkt uten gravering: fjern linjen og legg den til igjen uten _gravering_id
            var np = {};
            for (var k in p) if (k !== '_gravering_id') np[k] = p[k];
            ops.push(function () {
              return post(CHANGE, { id: it.key, quantity: 0 }).then(function () {
                return post(ADD, { items: [{ id: it.variant_id, quantity: it.quantity, properties: np }] });
              });
            });
          }
        });
        return ops.reduce(function (chain, op) { return chain.then(op); }, Promise.resolve())
          .then(function () { return ops.length; });
      })
      .then(function (n) { busy = false; if (n) document.dispatchEvent(new CustomEvent('cart:refresh')); })
      .catch(function (e) { busy = false; console.error('pippei-gravering', e); });
  }
  document.addEventListener('cart:updated', reconcile);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reconcile); else reconcile();
})();